import { Button, Icon, Text } from '@quintoandar-tokko/jopijs';
import styles from './dndCard.module.scss';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';

export function HideButton({ toggleHide, visible }) {
  return (
    <Button
      variant={['secondaryOutlined', 'small']}
      className={styles.btn}
      onClick={toggleHide}
    >
      <Icon
        icon={visible ? 'icon-ocultar' : 'icon-ver'}
        className={styles.icon}
      />
      <Text className={styles.btnText}>
        {Trans(translations, visible ? 'Hide' : 'Show')}
      </Text>
    </Button>
  );
}

export function ExpandButton({ toggleExpand, expanded }) {
  return (
    <Button
      variant={['secondaryOutlined', 'small']}
      className={styles.btn}
      onClick={toggleExpand}
    >
      <Icon
        icon="icon-ordenar"
        className={`${styles.icon} ${styles.iconExpand}`}
      />
      <Text className={styles.btnText}>
        {Trans(translations, expanded ? 'Collapse' : 'Expand')}
      </Text>
    </Button>
  );
}
